import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LangService } from '../../controller/lang-service';
import { ThemeService } from '../../controller/theme-service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './footer.html',
  styleUrl: './footer.css'
})
export class Footer {
  currentYear = new Date().getFullYear();
  showLangMenu: boolean = false;
  showThemeMenu: boolean = false;

  lang = inject(LangService);
  theme = inject(ThemeService);

  /** ✅ Signals that auto-update the template on theme change */
  themePreference = computed(() => this.theme.getThemePreference());
  isDarkMode = computed(() => this.theme.isDark());

  langs = [
    { code: 'en', label: 'English', flag: 'us' },
    { code: 'ar', label: 'العربية', flag: 'ps' },
    { code: 'es', label: 'Español', flag: 'es' }
  ];

  themes = [
    { code: 'light', label: 'Light', icon: '☀️' },
    { code: 'dark', label: 'Dark', icon: '🌙' },
    { code: 'system', label: 'System', icon: '💻' }
  ];

  constructor() { }

  get currentLang() {
    return this.lang.currentLang();
  }

  getFlagUrl(langCode: string): string {
    const lang = this.langs.find(l => l.code === langCode);
    return lang ? `https://flagcdn.com/w40/${lang.flag}.png` : '';
  }

  getLangLabel(lang: string): string {
    const found = this.langs.find(l => l.code === lang);
    return found?.label || lang;
  }

  getThemeLabel(code: string): string {
    const found = this.themes.find(t => t.code === code);
    return found?.label || code;
  }

  getThemeIcon(code: string): string {
    const found = this.themes.find(t => t.code === code);
    return found?.icon || '❓';
  }

  toggleLangMenu() {
    this.showLangMenu = !this.showLangMenu;
  }

  toggleThemeMenu() {
    this.showThemeMenu = !this.showThemeMenu;
    this.showLangMenu = false;
  }

  changeLang(lang: string) {
    this.lang.setLang(lang);
    this.showLangMenu = false;
  }

  changeTheme(code: string) {
    this.theme.setTheme(code as 'light' | 'dark' | 'system');
    this.showThemeMenu = false;
  }
}
